/**
 * Service to manage user identification
 */
export const userService = {
  /**
   * Get unique user ID - creates one if it doesn't exist
   */
  getUserId() {
    let userId = localStorage.getItem('cognimates_copilot_user_id');
    
    if (!userId) {
      // Generate a new UUID
      userId = this.generateUUID();
      localStorage.setItem('cognimates_copilot_user_id', userId);
    }
    
    return userId;
  },
  
  /**
   * Generate a UUID v4
   */
  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : ((r & 0x3) | 0x8);
      return v.toString(16);
    });
  }
};
